<template lang="pug">
.funnel-wrap
  .funneled.main-container-small(:class="{'center-logo': !showCart}")
    .checkout(v-if="route.path.indexOf('/checkout') === 0")
      Icon(name="lock" fill="white")
      | {{ __('Checkout') }}
    rogue-link.logo-wrap(to="/" aria-label="Link to Homepage")
      StaticImage.header-logo(src='/UI/logos/rogue-logo_zkxnnm.svg' :alt="$rogue.site.name" :width="275" :height="43")
    rogue-link.cart-wrap(v-if="showCart" to="/cart" aria-label="Go to Cart")
      Icon(name="cart" fill="white")
      | {{ cartQty }}
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useListStore } from '@/js/stores/listStore'

const route = useRoute()
const listStore = useListStore()

const cartQty = computed<number>(() => listStore.cartQty)
const showCart = computed<boolean>(() => route.name !== 'link-device')
</script>
<style lang="scss" scoped>

.header-logo {
  height: 19px;
  width: 122px;
}

.funnel-wrap {
  background-color: $color-black;
}

.funneled {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 51px;

  &.center-logo {
    justify-content: center;
  }
}

.cart-wrap, .checkout {
  color: $color-white;
  font-size: $size-xxs;
  display: flex;
  align-items: center;
  text-decoration: none;
}

.icon {
  margin-right: $space-xxs;
  width: $size-s;
}

@include all-desktop() {
  .funneled {
    height: 80px;
  }
  .checkout {
    display: none;
  }
  .header-logo {
    height: 32px;
    width: 206px;
  }
}
</style>
